import { useEffect, useState } from 'react';
import { CompaniesService } from '../../services/companies.service';
import AccountStepper from './accounts.stepper';

const AddAccountViewWrapper = () => {
  const [companies, setCompanies] = useState([]);

  const getCompanies = async () => {
    const data = await CompaniesService.getCompanies();
    setCompanies(data.map((item: any) => ({ value: item._id, label: item.name })));
  };

  useEffect(() => {
    getCompanies();
  }, []);

  return (
    <AccountStepper
      Companies={companies}
      onSucess={() => window.history.back()}
      onCancel={() => window.history.back()}
    />
  );
};

export default AddAccountViewWrapper;
